import React from 'react'
import {
  Icon,
  SocialInstagram,
  SocialYoutube,
  SocialLinkedIn2,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

const socialLinks = [
  {
    href: '//www.linkedin.com/company/cgtrader/',
    ariaLabel: 'LinkedIn',
    icon: SocialLinkedIn2,
  },
  {
    href: '//www.youtube.com/cgtrader/',
    ariaLabel: 'YouTube',
    icon: SocialYoutube,
  },

  {
    href: '//www.instagram.com/cgtrader/',
    ariaLabel: 'Instagram',
    icon: SocialInstagram,
    size: { width: '22', height: '22' },
  },
]

function SocialMediaLinks() {
  return (
    <div className="footer-social">
      <div className="social-footer-container">
        {socialLinks.map((social) => (
          <a
            key={social.ariaLabel}
            className="footer-social__link"
            href={social.href}
            target="_blank"
            aria-label={social.ariaLabel}
            rel="noreferrer"
          >
            <Icon
              svgComponent={social.icon}
              color="light"
              className={social.iconClassName}
              size={social.size}
            />
          </a>
        ))}
      </div>
    </div>
  )
}

export default SocialMediaLinks
